import { buildUrlParams } from '@/utils/build-params/build-params';
import { fetchPersea } from '@/config/axios/config-axios';
import axios from 'axios';

export const findByWallet = async (wallet: string) => {
  const params = {
    domain: import.meta.env.VITE_DOMAIN,
    main_key: String(wallet).toUpperCase(),
    limit: 1,
    page: 0,
    order: 'main_key',
    cache: true
  }
  const query = buildUrlParams(params);
  return await fetchPersea(`/user?${query}`, 'GET')
};

type userParam = {
  address: string,
  email: string,
  magic_token?: string,
  signature?: string,
  message?: string
}

export const create = async (domain: string, blockchain: string, user: Partial<userParam>) => {
  const baseData = {
    'domain': domain,
    'blockchain_name': blockchain,
    'homepage': '',
    'username': user?.address,
    'email': user.email,
    'about': '',
    'twitter': localStorage.getItem('twitter') || '',
    'facebook': '',
    'profile_pic_url': '',
    'telegram': '',
    'banner_url': '',
    'role': 1,
    'action': 'USER_CREATED'
  };

  const data = user.magic_token
    ? { ...baseData, 'magic_token': user.magic_token }
    : { ...baseData, 'signature': user.signature, 'message': user.message };

  const params = user?.magic_token
    ? { domain, magic_token: user?.magic_token }
    : { domain, message: user?.message, signature: user?.signature };

  const query = buildUrlParams(params);
  const full_url = `${import.meta.env.VITE_URL_API}/user?${query}`
  const result = axios.post(full_url, data, {
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': import.meta.env.VITE_X_API_KEY
    }
  })
  const response = await result;
  return response.data;
}

export const generateJwt = async (domain: string, message: string, signature: string, magic_token: string) => {
  const url = magic_token ?
    `${import.meta.env.VITE_URL_API}/auth?domain=${domain}&magic_token=${magic_token}&cache=true` :
    `${import.meta.env.VITE_URL_API}/auth?domain=${domain}&message=${message}&signature=${signature}&cache=true`
  const result = await axios.get(url, {
    headers: {
      'X-API-Key': import.meta.env.VITE_X_API_KEY
    }
  })

  return result?.data ?? null;
}
